import { render, staticRenderFns } from "./BasicSetting.vue?vue&type=template&id=2b292b03"
import script from "./BasicSetting.vue?vue&type=script&lang=js"
export * from "./BasicSetting.vue?vue&type=script&lang=js"
import style0 from "./BasicSetting.vue?vue&type=style&index=0&id=2b292b03&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports